/** @format */

import React, { useState, useRef, useEffect } from 'react'
import * as Styles from './style'
import { Formik } from 'formik'
import * as Yup from 'yup'

import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import close from '../../../assets/images/close.png'
import { InputGroup } from '../../../shared/InputGroup/InputGroup'
import { SelectGroup } from '../../../shared/SelectGroup/SelectGroup'

import Select from 'react-select'
import CreatableSelect from 'react-select/creatable'
import {
  getAllStates,
  getDistrictsByState,
  getBlocksByDistrict,
  getVillagesByBlocks,
} from '../../../shared/Constants/locations'
import {
  editSingleCluster,
  resetErrorinEditCluster,
  resetMessageinEditCluster,
} from '../../../reduxLogic/reducers/clusters/editSingleClusterSlice'

import { getAllProjects } from '../../../reduxLogic/reducers/projects/getAllProjectSlice'
import { getAllClusters } from '../../../reduxLogic/reducers/clusters/getAllClustersSlice'
import { getAllUsers } from '../../../reduxLogic/reducers/auth/getAllUsersSlice'

// Update initial values to include new fields
const initialValues = {
  project: '',
  clusterName: '',
  beeMitras: [],
  status: '',
  state: '',
  district: '',
  comments: '',
}

const projectSchema = Yup.object().shape({})

const EditProjectForm = props => {
  const { error, message } = useSelector(state => state.editProject)
  const { openEditModal, setOpenEditModal, idToEdit, singleRow, data } = props
  console.log('Single Row: ', props)

  const [singleClusterData, setSingleClusterData] = useState(singleRow || {})
  const [isEditing, setIsEditing] = useState(false)
  const [selectedStatus, setSelectedStatus] = useState(singleClusterData.status)

  // Location states
  const rawState = Array.isArray(props.singleRow?.state) ? props.singleRow.state[0] : (props.singleRow?.state || '')
  const rawDistrict = Array.isArray(props.singleRow?.district) ? props.singleRow.district[0] : (props.singleRow?.district || '')

  const [selectedState, setSelectedState] = useState(rawState)
  const [selectedDistrict, setSelectedDistrict] = useState(rawDistrict)

  // Parse blocks
  const initialBlocks = (Array.isArray(props.singleRow?.block)
    ? props.singleRow.block
    : (props.singleRow?.block ? [props.singleRow.block] : [])
  ).map(b => (typeof b === 'object' ? b : { value: b, label: b }))
  const [selectedBlocks, setSelectedBlocks] = useState(initialBlocks)

  // Parse villages
  const initialVillages = (Array.isArray(props.singleRow?.village)
    ? props.singleRow.village
    : (props.singleRow?.village ? [props.singleRow.village] : [])
  ).map(v => (typeof v === 'object' ? v : { value: v, label: v }))
  const [selectedVillages, setSelectedVillages] = useState(initialVillages)

  // States list from FV replica locations data
  const states = React.useMemo(() => getAllStates(), [])

  // Districts list for selectedState
  const districts = React.useMemo(() => {
    if (!selectedState) return []
    return getDistrictsByState(selectedState)
  }, [selectedState])

  // Blocks list for selectedDistrict
  const availableBlocks = React.useMemo(() => {
    if (!selectedDistrict) return []
    return getBlocksByDistrict(selectedDistrict).map(b => ({ value: b, label: b }))
  }, [selectedDistrict])

  // Available villages for selectedDistrict and selectedBlocks
  const availableVillages = React.useMemo(() => {
    if (!selectedDistrict) return []
    return getVillagesByBlocks(selectedDistrict, selectedBlocks).map(v => ({
      value: v,
      label: v,
    }))
  }, [selectedDistrict, selectedBlocks])

  const [selectedBeeMitras, setSelectedBeeMitras] = useState([])
  const { allUsers } = useSelector(state => state.allUsers)

  const formikRef = useRef(null)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllProjects())
  }, [idToEdit])

  const { projectData } = useSelector(state => state.allProjects || {})

  useEffect(() => {
    if (singleClusterData) {
      formikRef.current.setValues(singleClusterData)
    }
    dispatch(getAllUsers('bee_mitra'))

  }, [singleClusterData])

  useEffect(() => {
    if(allUsers){
      let updatedValue = [];
      if (singleRow?.beeMitras && singleRow.beeMitras.length > 0) {
        updatedValue = singleRow.beeMitras.map(item => {
          const itemId = typeof item === 'object' ? item._id : item;
          const matchingItem = allUsers?.find(obj => obj.userInfo._id === itemId)
          return {
            value: itemId,
            label: matchingItem?.userInfo.name ? matchingItem?.userInfo.name : (typeof item === 'object' ? item.fullName : null),
          }
        });
      }
      setSelectedBeeMitras(updatedValue)
    console.log('Beemitras: ', updatedValue)
    }
  }, [allUsers])


  const handleLocationStateChange = tempState => {
    setSelectedState(tempState)
    setSelectedDistrict('')
    setSelectedBlocks([])
    setSelectedVillages([])
  }

  const handleLocationDistrictChange = tempDistrict => {
    setSelectedDistrict(tempDistrict)
    setSelectedBlocks([])
    setSelectedVillages([])
  }

  const handleClose = () => {
    setOpenEditModal(false)
  }

  const statusOptions = ['active', 'inactive']
  const handleSubmit = values => {
    setIsEditing(true)
    const clusterData = {
      ...values,
      clusterId: values.clusterId !== undefined ? values.clusterId : singleClusterData.clusterId,
      clusterName: values.clusterName !== undefined ? values.clusterName : singleClusterData.clusterName,
      status: selectedStatus || values.status || 'active',
      state: selectedState ? [selectedState] : (Array.isArray(props.singleRow?.state) ? props.singleRow.state : [props.singleRow?.state]),
      district: selectedDistrict ? [selectedDistrict] : (Array.isArray(props.singleRow?.district) ? props.singleRow.district : [props.singleRow?.district]),
      block: selectedBlocks ? selectedBlocks.map(b => b.value || b) : [],
      village: selectedVillages ? selectedVillages.map(v => v.value || v) : [],
    }
    let editId = singleClusterData?._id

    clusterData.beeMitras = selectedBeeMitras ? selectedBeeMitras.map(item => item.value) : []

    console.log('Edit ID: ', editId)

    console.log('Cluster Data: ', clusterData)

    dispatch(editSingleCluster({ editId, clusterData }))
      .then(() => dispatch(getAllClusters()))
      .then(() => setOpenEditModal(false))
      .then(() => setIsEditing(false))
      .catch(err => toast.error(`${err}`))
  }

  useEffect(() => {
    if (error) {
      toast.error(`${error}`)
      dispatch(resetErrorinEditCluster())
      dispatch(resetMessageinEditCluster())
    }
    if (!error && message) {
      toast.success('Project was updated successfully')
      dispatch(resetMessageinEditCluster())
    }
  }, [error, dispatch, message])

  return (
    <Styles.ModalWrapper>
      <Styles.ModalContent>
        {singleClusterData ? (
          <Formik
            initialValues={singleClusterData || initialValues}
            onSubmit={handleSubmit}
            validationSchema={projectSchema}
            innerRef={formikRef}
            validateOnMount
          >
            {formik => (
              <Styles.FormWithCloseButton>
                <Styles.CloseButtonDiv>
                  <h3>Edit Cluster</h3>
                  <Styles.FormCloseButton onClick={handleClose}>
                    <img src={close} alt="Close" />
                  </Styles.FormCloseButton>
                </Styles.CloseButtonDiv>

                <Styles.MainSupplierFormDiv>
                  {/* <Select
                    isSearchable
                    options={projectData?.map((project) => ({
                      value: project._id,
                      label: project.name,
                    }))}
                    onChange={(selectedOption) => {
                      formik.setFieldValue("project", selectedOption.value);
                    }}
                    selectedOption={projectData?.filter(
                      (project) => project._id === singleClusterData.projectId
                    )}
                  /> */}
                  {/* <Styles.RowFlex>
                    <SelectGroup
                      PlaceholderText="Status"
                      LabelText="Select status"
                      styles={{
                        container: provided => ({
                          width: '50px',
                        }),
                      }}
                      name="status"
                      onChange={e => {
                        handleStateChange(e.target.value)
                        formik.handleChange(e)
                      }}
                      value={selectedStatus}
                      options={statusOptions}
                      star="*"
                    />
                  </Styles.RowFlex> */}
                  <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                    {/* First column: Project Name */}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                      }}
                    >
                      <label htmlFor="projectName" style={{ fontWeight: '600' }}>Project Name:</label>
                      <span
                        style={{
                          border: '1px solid #d9d9d9',
                          borderRadius: '6px',
                          padding: '6px 10px',
                          backgroundColor: '#f8fafc',
                          color: '#334155',
                          fontSize: '13px',
                          fontWeight: '500',
                        }}
                      >
                        {props.singleRow.projectId?.name || props.singleRow.projectId}
                      </span>
                    </div>

                    {/* Cluster ID (Editable) */}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        flex: '1',
                        minWidth: '260px',
                      }}
                    >
                      <label htmlFor="clusterId" style={{ fontWeight: '600', minWidth: '80px' }}>Cluster ID:</label>
                      <input
                        type="text"
                        name="clusterId"
                        id="clusterId"
                        value={formik.values.clusterId || ''}
                        onChange={formik.handleChange}
                        style={{
                          border: '1px solid #d9d9d9',
                          borderRadius: '6px',
                          padding: '6px 10px',
                          fontSize: '14px',
                          width: '100%',
                          outline: 'none',
                        }}
                      />
                    </div>

                    {/* Cluster Name (Editable) */}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        flex: '1',
                        minWidth: '260px',
                      }}
                    >
                      <label htmlFor="clusterName" style={{ fontWeight: '600', minWidth: '95px' }}>Cluster Name:</label>
                      <input
                        type="text"
                        name="clusterName"
                        id="clusterName"
                        value={formik.values.clusterName || ''}
                        onChange={formik.handleChange}
                        style={{
                          border: '1px solid #d9d9d9',
                          borderRadius: '6px',
                          padding: '6px 10px',
                          fontSize: '14px',
                          width: '100%',
                          outline: 'none',
                        }}
                      />
                    </div>
                  </div>

                  {/* Location Row: State, District, Status */}
                  <div style={{ display: 'flex', gap: '16px', marginTop: '16px', flexWrap: 'wrap' }}>
                    <div style={{ flex: '1', minWidth: '200px' }}>
                      <label htmlFor="state" style={{ fontWeight: '600', display: 'block', marginBottom: '6px' }}>
                        State:
                      </label>
                      <select
                        name="state"
                        id="state"
                        value={selectedState}
                        onChange={e => handleLocationStateChange(e.target.value)}
                        style={{
                          border: '1px solid #d9d9d9',
                          borderRadius: '6px',
                          padding: '8px 12px',
                          fontSize: '14px',
                          width: '100%',
                          outline: 'none',
                          backgroundColor: '#fff',
                        }}
                      >
                        <option value="">Select State</option>
                        {states.map(s => (
                          <option key={s} value={s}>{s}</option>
                        ))}
                      </select>
                    </div>

                    <div style={{ flex: '1', minWidth: '200px' }}>
                      <label htmlFor="district" style={{ fontWeight: '600', display: 'block', marginBottom: '6px' }}>
                        District:
                      </label>
                      <select
                        name="district"
                        id="district"
                        value={selectedDistrict}
                        onChange={e => handleLocationDistrictChange(e.target.value)}
                        style={{
                          border: '1px solid #d9d9d9',
                          borderRadius: '6px',
                          padding: '8px 12px',
                          fontSize: '14px',
                          width: '100%',
                          outline: 'none',
                          backgroundColor: '#fff',
                        }}
                        disabled={!selectedState}
                      >
                        <option value="">Select District</option>
                        {districts.map(d => (
                          <option key={d} value={d}>{d}</option>
                        ))}
                      </select>
                    </div>

                    <div style={{ minWidth: '150px' }}>
                      <label htmlFor="status" style={{ fontWeight: '600', display: 'block', marginBottom: '6px' }}>
                        Status:
                      </label>
                      <select
                        name="status"
                        id="status"
                        value={selectedStatus || formik.values.status || 'active'}
                        onChange={e => {
                          setSelectedStatus(e.target.value);
                          formik.setFieldValue('status', e.target.value);
                        }}
                        style={{
                          border: '1px solid #d9d9d9',
                          borderRadius: '6px',
                          padding: '8px 12px',
                          fontSize: '14px',
                          fontWeight: '600',
                          color: (selectedStatus || formik.values.status) === 'inactive' ? '#d63031' : '#00b894',
                          backgroundColor: (selectedStatus || formik.values.status) === 'inactive' ? '#fff5f5' : '#e6fffa',
                          cursor: 'pointer',
                          width: '100%',
                        }}
                      >
                        <option value="active">🟢 Active</option>
                        <option value="inactive">🔴 Inactive</option>
                      </select>
                    </div>
                  </div>

                  {/* Location Row 2: Block(s) and Village(s) */}
                  <div style={{ display: 'flex', gap: '16px', marginTop: '16px', flexWrap: 'wrap' }}>
                    <div style={{ flex: '1', minWidth: '260px' }}>
                      <label htmlFor="block" style={{ fontWeight: '600', display: 'block', marginBottom: '6px' }}>
                        Block(s) / Mandal:
                      </label>
                      <CreatableSelect
                        isMulti
                        name="block"
                        value={selectedBlocks}
                        options={availableBlocks}
                        onChange={val => setSelectedBlocks(val || [])}
                        placeholder={selectedDistrict ? "Select or type block..." : "Select district first"}
                        isDisabled={!selectedDistrict}
                        styles={{
                          control: base => ({
                            ...base,
                            minHeight: '38px',
                            borderRadius: '6px',
                            borderColor: '#d9d9d9',
                          }),
                          menuPortal: base => ({ ...base, zIndex: 9999 }),
                        }}
                        menuPortalTarget={document.body}
                      />
                    </div>

                    <div style={{ flex: '1', minWidth: '260px' }}>
                      <label htmlFor="village" style={{ fontWeight: '600', display: 'block', marginBottom: '6px' }}>
                        Village(s):
                      </label>
                      <Select
                        isMulti
                        isSearchable
                        name="village"
                        value={selectedVillages}
                        options={availableVillages}
                        onChange={val => setSelectedVillages(val || [])}
                        placeholder={
                          selectedBlocks.length > 0
                            ? (availableVillages.length > 0 ? "Select village(s)..." : "No villages found for selected block")
                            : selectedDistrict
                            ? "Select block first..."
                            : "Select district & block first..."
                        }
                        styles={{
                          control: base => ({
                            ...base,
                            minHeight: '38px',
                            borderRadius: '6px',
                            borderColor: '#d9d9d9',
                          }),
                          menuPortal: base => ({ ...base, zIndex: 9999 }),
                        }}
                        menuPortalTarget={document.body}
                      />
                    </div>
                  </div>

                  <label htmlFor="beeMitras" style={{ marginTop: '15px' }}>
                    Assign BeeMitra
                  </label>
                  <Styles.RowFlex>
                    <Select
                      isMulti={true}
                      value={selectedBeeMitras}
                      options={allUsers?.map(beeMitra => ({
                        value: beeMitra.userInfo._id,
                        label: beeMitra.userInfo.name,
                      }))}
                      onChange={event => setSelectedBeeMitras(event)}
                      styles={{
                        container: provided => ({
                          width: '450px',
                        }),
                        control: base => ({
                          ...base,
                          minHeight: '30px', // Control the dropdown height
                        }),
                        menu: base => ({
                          ...base,
                          zIndex: 9999, // Ensures dropdown appears above other elements
                        }),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999, // Portal the dropdown so it doesn't get cut off
                        }),
                        option: base => ({
                          ...base,
                          cursor: 'pointer',
                        }),
                      }}
                      menuPortalTarget={document.body} // Ensure dropdown appears outside table
                    />
                  </Styles.RowFlex>
                </Styles.MainSupplierFormDiv>

                <Styles.CreateSupplierButton type="submit">
                  {!isEditing ? 'Save' : '...Saving'}
                </Styles.CreateSupplierButton>
              </Styles.FormWithCloseButton>
            )}
          </Formik>
        ) : (
          <h4>
            There was an error fetching data for Project with ID {idToEdit}
          </h4>
        )}
      </Styles.ModalContent>
    </Styles.ModalWrapper>
  )
}

export default EditProjectForm
